import PurchaseTypes from '@/common/enums/purchase-types.enum';

export default [
  {
    id: PurchaseTypes.CADENCE,
    name: 'Cadence Buy',
  },
  {
    id: PurchaseTypes.GUARANTEED,
    name: 'Guaranteed',
  },
  {
    id: PurchaseTypes.NON_GUARANTEED,
    name: 'Non-Guaranteed',
  },
];
